class CartDrawer extends HTMLElement {
  constructor() {
    super()

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    )
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    )
    // Internal state to guard duplicate refreshes
    this._refreshing = false
    this._lastRefreshed = 0
    this.setHeaderCartIconAccessibility()
  }

  connectedCallback() {
    if (this._includedBoxCartUpdateSubscribed) return
    this._includedBoxCartUpdateSubscribed = true

    this._includedBoxCartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      () => {
        if (!this.classList.contains("active")) return
        this.scheduleIncludedBoxCarouselInit()
      },
    )
  }

  disconnectedCallback() {
    if (this._includedBoxCartUpdateUnsubscriber) {
      this._includedBoxCartUpdateUnsubscriber()
      this._includedBoxCartUpdateUnsubscriber = undefined
    }
  }

  scheduleIncludedBoxCarouselInit() {
    this.initIncludedBoxCarousels()
    window.setTimeout(() => this.initIncludedBoxCarousels(), 150)
    window.setTimeout(() => this.initIncludedBoxCarousels(), 400)
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble")
    if (!cartLink) return
    cartLink.setAttribute("role", "button")
    cartLink.setAttribute("aria-haspopup", "dialog")
    // Interaction is handled by delegated listeners below to avoid re-binding on header re-renders
    cartLink.addEventListener("click", (event) => {
      event.preventDefault()
      // Open immediately for perceived performance, then sync contents
      this.open(cartLink)
      // Removing this.refreshFromServer() because it's already being called in the open function
      pushViewCartTag()
    })
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault()
        this.open(cartLink)
        // Removing this.refreshFromServer() because it's already being called in the open function
        pushViewCartTag()
      }
    })
  }

  async updateCartProperties(lastName, code) {
    // try {
    //   const cartResponse = await fetch("/cart.js")
    //   const cart = await cartResponse.json()
    //   const updates = cart.items.map((item) => {
    //     console.log("original_price==========", item.original_price)
    //     const payload = {
    //       id: item.id.toString(),
    //       properties: {
    //         _code: code,
    //         _lastName: lastName,
    //         _orgPrice: item.original_price,
    //         _disPrice: item.discounted_price,
    //       },
    //       quantity: item.quantity,
    //     }
    //     return fetch("/cart/change.js", {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify(payload),
    //     }).then((response) => response.json())
    //   })
    //   const results = await Promise.all(updates)
    //   console.log("Cart properties updated for the products in the cart:")
    //   console.log(results)
    // } catch (error) {
    //   console.error("Error updating cart properties:", error)
    // }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote)
    // Only trigger animation hook if not already open
    if (!this.classList.contains("active")) {
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add("animate", "active")
      })
      const initIncludedBoxAfterOpen = () => {
        this.scheduleIncludedBoxCarouselInit()
      }

      this.addEventListener(
        "transitionend",
        () => {
          const containerToTrapFocusOn = this.classList.contains("is-empty")
            ? this.querySelector(".drawer__inner-empty")
            : document.getElementById("CartDrawer")
          const focusElement =
            this.querySelector(".drawer__inner") ||
            this.querySelector(".drawer__close")
          trapFocus(containerToTrapFocusOn, focusElement)
          // Ensure slider initializes after drawer becomes visible
          if (typeof this.initAddOnMobileSlider === "function") {
            this.initAddOnMobileSlider()
          }
          initIncludedBoxAfterOpen()
        },
        { once: true },
      )

      window.setTimeout(() => {
        if (!this.classList.contains("active")) return
        initIncludedBoxAfterOpen()
      }, 400)
    } else {
      // Already open; ensure slider is initialized
      if (typeof this.initAddOnMobileSlider === "function") {
        this.initAddOnMobileSlider()
      }
      this.scheduleIncludedBoxCarouselInit()
    }

    document.body.classList.add("overflow-hidden")

    const mileageData = JSON.parse(localStorage.getItem("unitedActivated"))
    let lastName = null,
      code = null
    if (mileageData !== null && typeof mileageData.lastName !== "undefined") {
      lastName = mileageData.lastName
    }
    if (mileageData !== null && typeof mileageData.code !== "undefined") {
      code = mileageData.code
    }

    const data = {
      attributes: {},
    }
    data.attributes["_code"] = code
    data.attributes["_lastName"] = lastName
    // console.log("data===", data)
    // Send an AJAX request to update the cart
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const itemMapById = new Map()
        const deleteKeys = []

        cart.items.forEach((item) => {
          const { id, key, quantity, properties = {} } = item
          const existing = itemMapById.get(id)

          if (existing) {
            document
              .querySelectorAll(
                `cart-remove-button .custom-cart-remove-button.cart-remove-button[data-variant-id="${id}"]`,
              )
              .forEach((el, i) => {
                const row = el.closest("tr")
                if (row && i > 0) {
                  row.style.display = "none" // Hides the second+ matching row
                }
              })
            const currentPropsCount = Object.keys(properties).length
            const existingPropsCount = Object.keys(existing.properties).length

            // Determine which item to keep
            const keepItem =
              currentPropsCount >= existingPropsCount ? item : existing
            const deleteItem =
              currentPropsCount >= existingPropsCount ? existing : item

            // Sum quantities
            keepItem.quantity += deleteItem.quantity

            // Store updated and mark other for deletion
            itemMapById.set(id, keepItem)
            deleteKeys.push(deleteItem.key)
          } else {
            itemMapById.set(id, { ...item })
          }
        })

        if (!deleteKeys.length) return null

        // Prepare updates: keep only the merged item with quantity
        const updates = {}

        // Use `key` if properties exist (customized items), otherwise variant_id
        for (const item of itemMapById.values()) {
          updates[item.key] = item.quantity
        }

        // Set quantity 0 for items to delete
        for (const key of deleteKeys) {
          updates[key] = 0
        }

        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        })
      })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((updatedCart) => {
        if (updatedCart) this.refreshFromServer()
      })
      .catch((error) => {
        console.error("Error updating cart:", error)
      })
  }

  close() {
    this.classList.remove("active")
    removeTrapFocus(this.activeElement)
    document.body.classList.remove("overflow-hidden")
  }

  async refreshFromServer() {
    // Debounce/guard to prevent continuous refresh loops
    if (this._refreshing) return
    const now = Date.now()
    if (now - (this._lastRefreshed || 0) < 500) return
    this._refreshing = true
    try {
      const cartUrl = (window.routes && window.routes.cart_url) || "/cart"
      const res = await fetch(
        `${cartUrl}?section_id=cart-drawer&ts=${Date.now()}`,
        {
          cache: "no-store",
          credentials: "same-origin",
        },
      )
      const htmlText = await res.text()
      const doc = new DOMParser().parseFromString(htmlText, "text/html")

      const innerTarget = this.querySelector("#CartDrawer .drawer__inner")
      const innerSource = doc.querySelector("#CartDrawer .drawer__inner")
      // Capture which bundle dropdowns are open from current DOM immediately before replace
      // (so if user opened one while the section fetch was in flight, we preserve it)
      const openBundleItemIds = []
      const openIncludedBoxLineKeys = []
      if (innerTarget) {
        innerTarget
          .querySelectorAll(".cart-item__bundle-toggle[aria-expanded='true']")
          .forEach((btn) => {
            const row = btn.closest("tr[id]")
            if (row && row.id) openBundleItemIds.push(row.id)
          })
        innerTarget
          .querySelectorAll(".cart-included-in-box[open][data-line-key]")
          .forEach((details) => {
            openIncludedBoxLineKeys.push(details.dataset.lineKey)
          })
      }
      if (innerTarget && innerSource) innerTarget.replaceWith(innerSource)
      // Re-open interactive rows after replace (defer so DOM is settled; avoids first open closing)
      const idsToRestore = openBundleItemIds.slice()
      const includedBoxKeysToRestore = openIncludedBoxLineKeys.slice()
      requestAnimationFrame(() => {
        idsToRestore.forEach((id) => {
          const row = this.querySelector(`#${CSS.escape(id)}`)
          if (row) {
            const btn = row.querySelector(".cart-item__bundle-toggle")
            const list = row.querySelector(".cart-item__bundle-list")
            if (btn && list) {
              btn.setAttribute("aria-expanded", "true")
              list.classList.add("is-open")
            }
          }
        })
        includedBoxKeysToRestore.forEach((lineKey) => {
          this.querySelectorAll(".cart-included-in-box").forEach((details) => {
            if (details.dataset.lineKey === lineKey) details.open = true
          })
        })
        this.scheduleIncludedBoxCarouselInit()
      })

      const footerTarget = this.querySelector(".cart-drawer__footer")
      const footerSource = doc.querySelector(".cart-drawer__footer")
      if (footerTarget && footerSource) footerTarget.replaceWith(footerSource)

      // Sync empty state class on host
      let drawerIsEmpty = false
      const sourceHost = doc.querySelector("cart-drawer")
      if (sourceHost) {
        drawerIsEmpty = sourceHost.classList.contains("is-empty")
      } else {
        drawerIsEmpty = !!doc.querySelector(".drawer__inner-empty")
      }
      this.classList.toggle("is-empty", drawerIsEmpty)

      // Ensure overlay close still works after replacement
      const overlay = this.querySelector("#CartDrawer-Overlay")
      if (overlay) {
        overlay.removeEventListener("click", this.close)
        overlay.addEventListener("click", this.close.bind(this))
      }

      // Re-apply summary accessibility on replaced details blocks
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
      if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
        this.setSummaryAccessibility(cartDrawerNote)
      }

      // Re-bind checkout started flag on the new checkout button
      const checkoutBtn = this.querySelector("#CartDrawer-Checkout")
      if (checkoutBtn) {
        checkoutBtn.addEventListener("click", () => {
          try {
            sessionStorage.setItem("checkout_started", "true")
          } catch (_) {}
        })
      }

      // Re-initialize add-on slider after dynamic content injection
      // this.initAddOnMobileSlider()
    } catch (err) {
      console.error("[CartDrawer] Failed to refresh from server", err)
    } finally {
      this._lastRefreshed = Date.now()
      this._refreshing = false

      // Publish the event to signal the drawer content has been refreshed
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "refreshFromServer",
        cartData: null,
      })
    }
    if (typeof startDiscountCountdowns === "function") {
      startDiscountCountdowns()
    }
    if (typeof initBadges === "function") {
      initBadges()
    }
  }

  initIncludedBoxCarousels() {
    const isCarouselScrollable = (carousel) =>
      carousel.scrollWidth > carousel.clientWidth + 1

    this.querySelectorAll(".cart-included-in-box__carousel").forEach(
      (carousel) => {
        const details = carousel.closest(".cart-included-in-box")
        const list = carousel.querySelector(".cart-included-in-box__list")

        const updateScrollState = () => {
          if (!details?.open) return
          details.classList.toggle(
            "cart-included-in-box--scroll",
            isCarouselScrollable(carousel),
          )
        }

        const scheduleScrollStateUpdate = (resetScroll = false) => {
          const run = () => {
            if (resetScroll) carousel.scrollLeft = 0
            updateScrollState()
          }

          if (!details?.open) {
            run()
            return
          }

          requestAnimationFrame(() => {
            run()
            requestAnimationFrame(run)
          })
          ;[100, 350].forEach((delay) => {
            window.setTimeout(run, delay)
          })

          carousel
            .querySelectorAll(".cart-included-in-box__image")
            .forEach((image) => {
              if (image.complete) return
              image.addEventListener("load", run, { once: true })
              image.addEventListener("error", run, { once: true })
            })
        }

        scheduleScrollStateUpdate(
          carousel.dataset.includedBoxMeasured !== "true",
        )
        carousel.dataset.includedBoxMeasured = "true"

        if (carousel.dataset.includedBoxBound === "true") return

        carousel.dataset.includedBoxBound = "true"

        if (details) {
          details.addEventListener("toggle", () => {
            if (details.open) scheduleScrollStateUpdate(true)
          })
        }

        if (typeof ResizeObserver !== "undefined") {
          const resizeObserver = new ResizeObserver(updateScrollState)
          resizeObserver.observe(carousel)
          if (list) resizeObserver.observe(list)
        } else {
          window.addEventListener("resize", updateScrollState)
        }

        const getScrollStep = () => {
          const item = carousel.querySelector(".cart-included-in-box__item")
          const listEl = carousel.querySelector(".cart-included-in-box__list")
          if (!item || !listEl) return 80

          const gapValue = window.getComputedStyle(listEl).columnGap
          const gap = Number.parseFloat(gapValue) || 8

          return item.offsetWidth + gap
        }

        const snapToNearestBox = () => {
          if (!isCarouselScrollable(carousel)) return

          const step = getScrollStep()
          const targetIndex = Math.round(carousel.scrollLeft / step)
          carousel.scrollTo({
            left: targetIndex * step,
            behavior: "smooth",
          })
        }

        carousel.addEventListener("dragstart", (event) => {
          event.preventDefault()
        })

        carousel.addEventListener(
          "wheel",
          (event) => {
            if (!details?.open || !isCarouselScrollable(carousel)) return

            const absX = Math.abs(event.deltaX)
            const absY = Math.abs(event.deltaY)

            // Shift + vertical wheel = horizontal scroll (classic mouse UX)
            if (event.shiftKey && absY >= 1) {
              event.preventDefault()
              carousel.scrollLeft += event.deltaY
              return
            }

            // Only capture clearly horizontal gestures (trackpad left/right).
            // Vertical Apple-mouse / trackpad scroll passes through to the drawer.
            if (absX <= absY || absX < 1) return

            event.preventDefault()
            carousel.scrollLeft += event.deltaX
          },
          { passive: false },
        )

        let isDragging = false
        let dragStartX = 0
        let dragScrollLeft = 0
        let activePointerId = null

        const endDrag = (event) => {
          if (!isDragging) return
          if (
            event &&
            activePointerId !== null &&
            event.pointerId !== activePointerId
          )
            return

          isDragging = false
          activePointerId = null
          carousel.classList.remove("is-dragging")

          if (event?.pointerId != null) {
            try {
              carousel.releasePointerCapture(event.pointerId)
            } catch (_) {}
          }

          snapToNearestBox()
        }

        const onPointerMove = (event) => {
          if (!isDragging || event.pointerId !== activePointerId) return

          event.preventDefault()
          const walk = event.clientX - dragStartX
          carousel.scrollLeft = dragScrollLeft - walk
        }

        carousel.addEventListener("pointermove", onPointerMove)
        carousel.addEventListener("pointerup", endDrag)
        carousel.addEventListener("pointercancel", endDrag)

        carousel.addEventListener(
          "pointerdown",
          (event) => {
            if (!details?.open || !isCarouselScrollable(carousel)) return
            if (event.button !== 0) return
            if (event.pointerType === "touch") return

            event.preventDefault()
            isDragging = true
            activePointerId = event.pointerId
            dragStartX = event.clientX
            dragScrollLeft = carousel.scrollLeft
            carousel.classList.add("is-dragging")

            try {
              carousel.setPointerCapture(event.pointerId)
            } catch (_) {}
          },
          { passive: false },
        )
      },
    )
  }

  initAddOnMobileSlider(retry = 0) {
    // try {
    //   const $ = window.jQuery
    //   if (!$ || !$.fn || !$.fn.slick) {
    //     if (retry < 15) {
    //       return setTimeout(() => this.initAddOnMobileSlider(retry + 1), 150)
    //     }
    //     return
    //   }
    //   // Ensure drawer is visible; slick mis-measures hidden elements
    //   const hostVisible = this.classList.contains("active")
    //   const drawerEl = this.querySelector("#CartDrawer")
    //   const hasSize = drawerEl && drawerEl.getBoundingClientRect().width > 0
    //   if ((!hostVisible || !hasSize) && retry < 15) {
    //     return setTimeout(() => this.initAddOnMobileSlider(retry + 1), 150)
    //   }
    //   const $slider = $(this).find(".add-on-mobile--swiper .add-on--card-list")
    //   if (!$slider.length) return
    //   if ($slider.hasClass("slick-initialized")) {
    //     try {
    //       $slider.slick("unslick")
    //     } catch (_) {}
    //   }
    //   const count = $slider.children().length
    //   if (count > 1) {
    //     $slider.slick({
    //       dots: true,
    //       infinite: false,
    //       slidesToShow: 1.2,
    //       vertical: false,
    //       arrows: false,
    //       draggable: true,
    //     })
    //   } else if (count === 1) {
    //     const card = document.querySelector(
    //       ".add-on-mobile--swiper .add-on--card",
    //     )
    //     if (card) {
    //       card.style.maxWidth = "71.061%"
    //       if (window.innerWidth > 768) {
    //         $(".add-on-mobile--swiper").css({ "padding-right": "4rem" })
    //       } else {
    //         $(".add-on-mobile--swiper").css({ "padding-right": "1.6rem" })
    //       }
    //     }
    //   }
    // } catch (e) {
    //   console.warn("[CartDrawer] add-on slider init skipped:", e)
    // }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button")
    cartDrawerNote.setAttribute("aria-expanded", "false")

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      )
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      )
    })

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape)
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty")
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      )
    })

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      )
      this.open()
      pushViewCartTag()
      // Publish the event to signal the drawer content has been rendered
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "renderContents",
        cartData: parsedState,
      })
    })
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ]
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

function changeVals(payload, cartId) {
  const mileageData = JSON.parse(localStorage.getItem("unitedActivated"))
  let code = mileageData?.code || "null"
  let lastName = mileageData?.lastName || "null"
  const data = {
    attributes: {},
  }
  data.attributes["_code"] = code
  data.attributes["_lastName"] = lastName

  // Send an AJAX request to update the cart
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((cart) => {
      document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }))
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }))
      // Optionally, perform additional actions after update
    })
    .catch((error) => {
      console.error("Error updating cart:", error)
    })
  document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }))
  document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }))
  document.dispatchEvent(new CustomEvent("cart:update ", { bubbles: true }))
  for (let i = 0; i < payload.length; i++) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload[i]),
    })
      .then((response) => response.json())
      .then((cartVal) => {
        console.log("success")
        document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }))
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true }),
        )
      })
    document.addEventListener("cart:updated", function () {
      console.log("teste")
    })
    document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }))
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }))
    document.dispatchEvent(new CustomEvent("cart:update ", { bubbles: true }))
    // return false;
    // updateCartItemAttr(cartId,original_price,final_price)
  }
}

customElements.define("cart-drawer", CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ]
  }
}

customElements.define("cart-drawer-items", CartDrawerItems)

// Delegated handler so re-rendered cart icon still opens and refreshes the drawer
;(function () {
  if (window.__cartIconDelegationBound) return
  window.__cartIconDelegationBound = true

  function activateDrawer(e) {
    const icon =
      e.target && e.target.closest && e.target.closest("#cart-icon-bubble")
    if (!icon) return
    // Avoid interfering on the full cart page
    if (location.pathname.replace(/\/+$/, "") === "/cart") return
    e.preventDefault()
    const drawer = document.querySelector("cart-drawer")
    if (!drawer) return
    drawer.open(icon)
    // Commenting it out because it's already being called in the drawer's open function
    // if (typeof drawer.refreshFromServer === "function")
    //   drawer.refreshFromServer()
  }

  document.addEventListener("click", activateDrawer)
  document.addEventListener("keydown", (e) => {
    if ((e.code || "").toUpperCase() === "SPACE") activateDrawer(e)
  })
})()

function decodeCartText(value) {
  if (typeof value !== "string" || value.indexOf("&") === -1) return value
  const el = document.createElement("textarea")
  el.innerHTML = value
  return el.value
}

async function pushViewCartTag() {
  try {
    const cartResponse = await fetch("/cart.js")
    const cartData = await cartResponse.json()
    const { currency, total_price } = cartData
    const cartItems = []
    const lineItems = cartData.items
    for (const line_item of lineItems) {
      cartItems.push({
        item_id: line_item.product_id,
        item_name: decodeCartText(line_item.product_title || line_item.title),
        item_category: decodeCartText(line_item.product_type),
        item_handle: line_item.handle,
        item_variant: decodeCartText(line_item.variant_title),
        price: line_item.price / 100,
        quantity: line_item.quantity,
      })
    }
    dataLayer.push({
      event: "view_cart",
      ecommerce: { currency, value: total_price / 100, items: cartItems },
    })
  } catch (error) {
    console.error("Error fetching cart data:", error)
  }
}
